export const movies = [
  {
    id: "m1",
    title: "深渊回响",
    type: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "内地",
    genres: ["科幻", "悬疑"],
    director: "陆维舟",
    actors: ["程景明", "林知夏", "高野"],
    duration: "128分钟",
    language: "国语",
    rating: 8.7,
    popularity: 9820,
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20silhouette%20facing%20a%20glowing%20deep%20space%20rift%2C%20cold%20teal%20and%20ember%20orange%20palette%2C%20volumetric%20light%20rays%2C%20epic%20scale%2C%20dramatic%20contrast%2C%20subtle%20film%20grain%2C%20minimalist%20composition%2C%20no%20text&width=600&height=900&seq=dh-m1-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20space%20scene%20with%20a%20giant%20swirling%20nebulous%20rift%20and%20a%20tiny%20spaceship%20silhouette%2C%20teal%20and%20warm%20amber%20glow%2C%20volumetric%20light%2C%20cinematic%20wide%20composition%2C%20atmospheric%20depth%2C%20no%20text&width=1920&height=1080&seq=dh-m1-backdrop&orientation=landscape",
    synopsis: "近未来，一支深空探测队在一次异常信号探测中失联，唯一返回的宇航员却发现记忆出现断层。为了找回真相，他孤身重返那片被称为深渊的星域，在时空回响中直面人类文明隐藏已久的秘密。",
    update: "2025-08-22 上映"
  },
  {
    id: "m2",
    title: "长安夜行",
    type: "movie",
    categoryLabel: "电影",
    year: 2024,
    region: "内地",
    genres: ["古装", "动作"],
    director: "沈墨白",
    actors: ["顾长风", "苏晚棠", "祁南"],
    duration: "142分钟",
    language: "国语",
    rating: 8.2,
    popularity: 8640,
    poster: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20period%20action%20film%20poster%20with%20a%20cloaked%20swordsman%20standing%20on%20a%20rooftop%20above%20a%20misty%20lantern-lit%20city%20at%20night%2C%20deep%20crimson%20and%20gold%20palette%2C%20ink%20wash%20texture%2C%20dramatic%20rim%20light%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=dh-m2-poster&orientation=portrait",
    backdrop: "",
    synopsis: "盛唐长安，一场看似普通的刺客案牵出朝堂与江湖的暗涌。夜行司少年与神秘女捕快携手追查，在灯火阑珊的长街与高墙深巷之间，揭开一段被尘封二十年的往事。",
    update: "2024-11-05 上映"
  },
  {
    id: "m3",
    title: "热带往事",
    type: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "港台",
    genres: ["犯罪", "剧情"],
    director: "何家骏",
    actors: ["陈子昂", "叶芷晴", "罗志森"],
    duration: "116分钟",
    language: "粤语",
    rating: 7.9,
    popularity: 7120,
    poster: "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20drama%20poster%20set%20in%20a%20humid%20tropical%20city%2C%20lone%20figure%20under%20neon%20signs%20reflected%20on%20wet%20asphalt%2C%20deep%20emerald%20and%20warm%20amber%20tone%2C%20heavy%20atmosphere%2C%20moody%20lighting%2C%20grainy%20texture%2C%20no%20text&width=600&height=900&seq=dh-m3-poster&orientation=portrait",
    backdrop: "",
    synopsis: "闷热的南方港口城市，一桩看似简单的走私案让一名落魄警探卷入三股势力的角力。随着调查深入，他发现真相与十年前的旧案紧紧缠绕，而每一个人都在为生存隐瞒着什么。",
    update: "2025-06-18 上映"
  },
  {
    id: "m4",
    title: "星舰黎明",
    type: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "美国",
    genres: ["科幻", "冒险"],
    director: "Marcus Reed",
    actors: ["Ethan Cole", "Naomi Vance", "Leo Grant"],
    duration: "156分钟",
    language: "英语",
    rating: 8.4,
    popularity: 9510,
    poster: "https://readdy.ai/api/search-image?query=Grand%20sci-fi%20adventure%20movie%20poster%20with%20a%20massive%20starship%20emerging%20from%20a%20golden%20sunrise%20above%20a%20planet%2C%20orange%20and%20deep%20indigo%20gradient%2C%20lens%20flare%2C%20epic%20scale%2C%20clean%20futuristic%20design%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=dh-m4-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Massive%20futuristic%20starship%20floating%20above%20a%20golden%20planet%20horizon%20at%20sunrise%2C%20warm%20orange%20and%20deep%20indigo%20sky%2C%20cinematic%20wide%20composition%2C%20lens%20flare%2C%20epic%20sci-fi%20scale%2C%20atmospheric%2C%20no%20text&width=1920&height=1080&seq=dh-m4-backdrop&orientation=landscape",
    synopsis: "当地球最后的宜居带消失，人类派出世代星舰驶向未知星系。年轻的领航员在一场突如其来的能量风暴后，发现船上沉睡的并非只有殖民者，还有一段足以改写人类命运的历史。",
    update: "2025-07-30 上映"
  },
  {
    id: "m5",
    title: "无声告白",
    type: "movie",
    categoryLabel: "电影",
    year: 2023,
    region: "内地",
    genres: ["剧情", "家庭"],
    director: "周晚晴",
    actors: ["许静姝", "马淮安", "小演员 田禾"],
    duration: "108分钟",
    language: "国语",
    rating: 8.0,
    popularity: 6210,
    poster: "https://readdy.ai/api/search-image?query=Quiet%20family%20drama%20movie%20poster%20with%20a%20mother%20and%20child%20silhouette%20by%20a%20window%20in%20warm%20afternoon%20light%2C%20muted%20beige%20and%20soft%20brown%20palette%2C%20gentle%20emotional%20tone%2C%20minimal%20negative%20space%2C%20filmic%20texture%2C%20no%20text&width=600&height=900&seq=dh-m5-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一位母亲在整理旧物时发现了女儿从未寄出的信件，信中写满了她从未说出口的心事。为了读懂女儿，她开始重新走过女儿成长的每一个角落，也重新认识了自己。",
    update: "2023-09-15 上映"
  },
  {
    id: "m6",
    title: "追风少年",
    type: "movie",
    categoryLabel: "电影",
    year: 2024,
    region: "内地",
    genres: ["运动", "青春"],
    director: "韩立川",
    actors: ["林浩然", "宋清越", "邓一诺"],
    duration: "120分钟",
    language: "国语",
    rating: 7.6,
    popularity: 5980,
    poster: "https://readdy.ai/api/search-image?query=Youthful%20sports%20movie%20poster%20with%20a%20teenage%20cyclist%20racing%20forward%20under%20a%20bright%20sky%2C%20energetic%20orange%20and%20sky%20blue%20palette%2C%20motion%20blur%2C%20sunny%20free%20spirit%20tone%2C%20dynamic%20diagonal%20composition%2C%20no%20text&width=600&height=900&seq=dh-m6-poster&orientation=portrait",
    backdrop: "",
    synopsis: "小城少年在废弃车棚里修好了人生第一辆公路车，从此爱上了风驰电掣的自由。当梦想与家庭、友情与现实不断碰撞，他必须学会在冲向终点线之前，先找到属于自己的方向。",
    update: "2024-05-01 上映"
  },
  {
    id: "m7",
    title: "暗流",
    type: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    director: "Kim Do-yun",
    actors: ["Park Jae-ho", "Yoon Se-ra", "Choi Min"],
    duration: "124分钟",
    language: "韩语",
    rating: 8.3,
    popularity: 8030,
    poster: "https://readdy.ai/api/search-image?query=Tense%20psychological%20thriller%20movie%20poster%20with%20a%20reflection%20of%20a%20man%20in%20a%20dark%20flooded%20tunnel%2C%20cold%20steel%20blue%20and%20rust%20orange%20contrast%2C%20suspenseful%20mood%2C%20high%20contrast%20lighting%2C%20gritty%20texture%2C%20no%20text&width=600&height=900&seq=dh-m7-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一名刑警在调查连环失踪案时，发现所有线索都指向自己早已遗忘的过去。真相如暗流般从平静的水面下涌出，逼迫他在正义与自保之间做出抉择。",
    update: "2025-09-12 上映"
  },
  {
    id: "m8",
    title: "雪国列车长",
    type: "movie",
    categoryLabel: "电影",
    year: 2022,
    region: "日本",
    genres: ["剧情", "历史"],
    director: "Yamada Kenji",
    actors: ["Sato Hiro", "Nakamura Aoi", "Ito Ren"],
    duration: "134分钟",
    language: "日语",
    rating: 7.8,
    popularity: 5240,
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20period%20drama%20poster%20with%20an%20old%20steam%20train%20crossing%20a%20snowy%20landscape%2C%20muted%20grey%20and%20warm%20lamp%20light%2C%20soft%20falling%20snow%2C%20gentle%20melancholic%20tone%2C%20wide%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=dh-m8-poster&orientation=portrait",
    backdrop: "",
    synopsis: "昭和年间，一位老列车长在最后一次值乘途中，遇到了形形色色的旅客。每一段短暂的相遇背后，都是一段关于时代、离别与坚持的动人故事。",
    update: "2022-12-10 上映"
  },
  {
    id: "m9",
    title: "都市迷航",
    type: "movie",
    categoryLabel: "电影",
    year: 2025,
    region: "港台",
    genres: ["科幻", "爱情"],
    director: "郑柏宇",
    actors: ["苏芷然", "方启铭", "关以豪"],
    duration: "112分钟",
    language: "粤语",
    rating: 7.4,
    popularity: 6480,
    poster: "https://readdy.ai/api/search-image?query=Futuristic%20romance%20movie%20poster%20with%20two%20people%20reaching%20for%20each%20other%20across%20a%20glitching%20city%20skyline%2C%20soft%20rose%20and%20violet%20accent%20over%20dark%20charcoal%2C%20dreamy%20neon%20haze%2C%20emotional%20sci-fi%20tone%2C%20no%20text&width=600&height=900&seq=dh-m9-poster&orientation=portrait",
    backdrop: "",
    synopsis: "在数据与记忆可以买卖的都市里，一对恋人因为一场系统故障失去了彼此的存在证明。为了找回共同拥有过的时光，他们在虚拟与现实交错的迷宫中不断重逢又分离。",
    update: "2025-04-26 上映"
  },
  {
    id: "m10",
    title: "荒原猎手",
    type: "movie",
    categoryLabel: "电影",
    year: 2024,
    region: "美国",
    genres: ["动作", "西部"],
    director: "Jack Sullivan",
    actors: ["Cole Bishop", "Rosa Delgado", "Hank Moore"],
    duration: "118分钟",
    language: "英语",
    rating: 7.5,
    popularity: 6690,
    poster: "https://readdy.ai/api/search-image?query=Rugged%20western%20action%20movie%20poster%20with%20a%20lone%20rider%20silhouette%20against%20a%20burning%20desert%20sunset%2C%20dusty%20terracotta%20and%20gold%20palette%2C%20heat%20haze%2C%20gritty%20texture%2C%20iconic%20lonely%20hero%20mood%2C%20no%20text&width=600&height=900&seq=dh-m10-poster&orientation=portrait",
    backdrop: "",
    synopsis: "荒漠边陲的小镇被一伙亡命之徒控制，沉默寡言的赏金猎人在追捕目标的途中意外卷入小镇的纷争。风沙与枪火之间，他必须决定自己是继续独行，还是为他人挺身而出。",
    update: "2024-10-18 上映"
  }
];

export const tvShows = [
  {
    id: "t1",
    title: "云上之城",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2025,
    region: "内地",
    genres: ["都市", "情感"],
    director: "许安然",
    actors: ["江疏影", "陆辰", "周雨桐"],
    duration: "每集45分钟",
    language: "国语",
    rating: 8.5,
    popularity: 9310,
    poster: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20series%20poster%20with%20a%20couple%20on%20a%20high-rise%20rooftop%20overlooking%20a%20glowing%20city%20skyline%20at%20dusk%2C%20warm%20amber%20and%20soft%20rose%20palette%2C%20elegant%20clean%20composition%2C%20romantic%20cinematic%20tone%2C%20no%20text&width=600&height=900&seq=dh-t1-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Glowing%20modern%20city%20skyline%20at%20dusk%20seen%20from%20a%20high%20rooftop%20terrace%2C%20warm%20amber%20and%20soft%20rose%20light%2C%20cinematic%20wide%20composition%2C%20elegant%20urban%20atmosphere%2C%20no%20text&width=1920&height=1080&seq=dh-t1-backdrop&orientation=landscape",
    synopsis: "三个背景迥异的年轻人因为一档创业节目走到一起，在高楼林立的都市里合力打造属于自己的事业与生活。爱情、友情与理想在云上之城交织，他们学会在现实里守护初心。",
    update: "全40集 · 已完结"
  },
  {
    id: "t2",
    title: "江湖令",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2024,
    region: "内地",
    genres: ["古装", "武侠"],
    director: "柳承砚",
    actors: ["沐云生", "楚青玄", "白芷"],
    duration: "每集42分钟",
    language: "国语",
    rating: 8.1,
    popularity: 8470,
    poster: "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20series%20poster%20with%20two%20heroes%20facing%20off%20beneath%20a%20waterfall%20in%20misty%20mountains%2C%20deep%20jade%20green%20and%20gold%20palette%2C%20flowing%20robes%20and%20long%20hair%2C%20dramatic%20ink%20texture%2C%20no%20text&width=600&height=900&seq=dh-t2-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Misty%20ancient%20mountain%20landscape%20with%20a%20solitary%20swordsman%20standing%20on%20a%20cliff%20ledge%2C%20deep%20jade%20green%20and%20gold%20haze%2C%20ink%20wash%20atmosphere%2C%20epic%20wuxia%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=dh-t2-backdrop&orientation=landscape",
    synopsis: "江湖动荡，一块失落多年的令牌成为各方争夺的焦点。身负血仇的少女与隐姓埋名的剑客结伴同行，在刀光剑影与权谋算计中，逐渐揭开令牌背后惊天的秘密。",
    update: "全36集 · 已完结"
  },
  {
    id: "t3",
    title: "暗夜侦探",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2025,
    region: "港台",
    genres: ["悬疑", "罪案"],
    director: "程国锋",
    actors: ["黎子墨", "何静仪", "吴展鹏"],
    duration: "每集40分钟",
    language: "粤语",
    rating: 8.6,
    popularity: 9050,
    poster: "https://readdy.ai/api/search-image?query=Moody%20crime%20detective%20series%20poster%20with%20a%20detective%20under%20a%20flickering%20streetlamp%20in%20a%20rainy%20alley%2C%20cold%20teal%20and%20warm%20amber%20contrast%2C%20cigarette%20smoke%2C%20noir%20atmosphere%2C%20high%20contrast%2C%20no%20text&width=600&height=900&seq=dh-t3-poster&orientation=portrait",
    backdrop: "",
    synopsis: "接连发生的案件都指向同一种手法，让经验丰富的侦探第一次感到不安。随着调查深入，他发现凶手似乎对城市中每一个被遗忘的角落都了如指掌，连同他自己不愿提起的过去。",
    update: "更新至第 24 集"
  },
  {
    id: "t4",
    title: "权谋天下",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2024,
    region: "内地",
    genres: ["历史", "权谋"],
    director: "司马鸿",
    actors: ["萧景琰", "秦婉如", "李元朗"],
    duration: "每集48分钟",
    language: "国语",
    rating: 8.8,
    popularity: 9620,
    poster: "https://readdy.ai/api/search-image?query=Historical%20political%20drama%20poster%20with%20an%20emperor%20in%20elaborate%20robes%20seated%20on%20a%20throne%20in%20a%20dim%20hall%2C%20deep%20crimson%20and%20marble%20gold%20palette%2C%20candlelight%2C%20solemn%20grand%20atmosphere%2C%20no%20text&width=600&height=900&seq=dh-t4-poster&orientation=portrait",
    backdrop: "",
    synopsis: "王朝更迭之际，一位出身寒门的谋士凭借过人的智慧步步为营，在朝堂的层层算计中周旋。权力的游戏没有赢家，只有活到最后的人，才能书写历史。",
    update: "全50集 · 已完结"
  },
  {
    id: "t5",
    title: "心动信号",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2025,
    region: "韩国",
    genres: ["都市", "爱情"],
    director: "Lee Ha-eun",
    actors: ["Han Ji-woo", "Seo Kang", "Bae Rin"],
    duration: "每集42分钟",
    language: "韩语",
    rating: 8.0,
    popularity: 7890,
    poster: "https://readdy.ai/api/search-image?query=Romantic%20comedy%20series%20poster%20with%20a%20cheerful%20couple%20sharing%20an%20umbrella%20on%20a%20sunny%20street%2C%20soft%20peach%20and%20cream%20palette%2C%20bright%20airy%20mood%2C%20playful%20warm%20tones%2C%20clean%20modern%20design%2C%20no%20text&width=600&height=900&seq=dh-t5-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一位工作狂职场女强人与一位温柔细腻的咖啡师因一次意外相遇，从此生活被彼此打乱节奏。在忙碌的都市生活中，他们学着放慢脚步，倾听自己内心真正的信号。",
    update: "更新至第 16 集"
  },
  {
    id: "t6",
    title: "时间旅人",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2025,
    region: "美国",
    genres: ["科幻", "悬疑"],
    director: "Alan Pierce",
    actors: ["Noah Bennett", "Grace Miller", "Ivan Petrov"],
    duration: "每集52分钟",
    language: "英语",
    rating: 8.4,
    popularity: 8560,
    poster: "https://readdy.ai/api/search-image?query=Time%20travel%20mystery%20series%20poster%20with%20a%20figure%20standing%20inside%20a%20glowing%20clock%20portal%20surrounded%20by%20floating%20gears%2C%20deep%20indigo%20and%20electric%20orange%20accents%2C%20surreal%20sci-fi%20tone%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=dh-t6-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一名物理学家意外获得了穿越时间的能力，却发现每一次改变都会引发无法预料的连锁反应。为了拯救所爱之人，他不得不一次次回到过去，直到面对那个最艰难的抉择。",
    update: "更新至第 10 集"
  },
  {
    id: "t7",
    title: "家宴",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2023,
    region: "内地",
    genres: ["家庭", "伦理"],
    director: "吴念慈",
    actors: ["老戏骨 郑培之", "何淑华", "林小满"],
    duration: "每集45分钟",
    language: "国语",
    rating: 8.2,
    popularity: 6720,
    poster: "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20series%20poster%20with%20a%20long%20dinner%20table%20full%20of%20home%20cooked%20dishes%20and%20family%20members%20gathered%2C%20cozy%20amber%20and%20soft%20green%20palette%2C%20homely%20warm%20atmosphere%2C%20no%20text&width=600&height=900&seq=dh-t7-poster&orientation=portrait",
    backdrop: "",
    synopsis: "每逢佳节，一大家人都会围坐在一起吃一顿家宴。看似热闹的饭桌之下，藏着几代人的心结与和解。随着老宅即将拆迁，一家人不得不重新面对那些被搁置多年的往事。",
    update: "全32集 · 已完结"
  },
  {
    id: "t8",
    title: "法界风云",
    type: "tv",
    categoryLabel: "电视剧",
    year: 2024,
    region: "美国",
    genres: ["律政", "剧情"],
    director: "Sofia Carter",
    actors: ["Daniel Brooks", "Emily Stone", "Mark Reyes"],
    duration: "每集48分钟",
    language: "英语",
    rating: 8.1,
    popularity: 7180,
    poster: "https://readdy.ai/api/search-image?query=Legal%20drama%20series%20poster%20with%20a%20confident%20lawyer%20standing%20in%20a%20grand%20courthouse%20hallway%2C%20deep%20navy%20and%20warm%20marble%20gold%20palette%2C%20strong%20side%20lighting%2C%20authoritative%20professional%20tone%2C%20no%20text&width=600&height=900&seq=dh-t8-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一位理想主义的年轻律师加入顶级律所后，发现自己必须在正义与利益之间不断权衡。一桩引发全城关注的案件，让他重新思考法律真正的意义，以及自己愿意为之坚持的底线。",
    update: "全22集 · 已完结"
  }
];

export const varietyShows = [
  {
    id: "v1",
    title: "星光大赏",
    type: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "内地",
    genres: ["音乐", "选秀"],
    director: "总导演 何灿",
    actors: ["导师阵容", "青年歌手", "特邀嘉宾"],
    duration: "每期90分钟",
    language: "国语",
    rating: 8.3,
    popularity: 8970,
    poster: "https://readdy.ai/api/search-image?query=Vibrant%20music%20talent%20show%20poster%20with%20a%20singer%20silhouette%20under%20a%20shower%20of%20golden%20stage%20lights%2C%20electric%20orange%20and%20deep%20magenta%20accents%2C%20energetic%20glamorous%20concert%20mood%2C%20sparkling%20highlights%2C%20no%20text&width=600&height=900&seq=dh-v1-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20golden%20spotlights%20and%20a%20large%20glowing%20screens%2C%20electric%20orange%20and%20warm%20violet%20lighting%2C%20energetic%20live%20music%20atmosphere%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1920&height=1080&seq=dh-v1-backdrop&orientation=landscape",
    synopsis: "一档聚焦新生代歌手的音乐竞演节目，选手们在舞台上用歌声讲述自己的故事。导师点评、现场观众投票与真实的情感碰撞，让每一期都充满惊喜与感动。",
    update: "更新至第 8 期"
  },
  {
    id: "v2",
    title: "快乐大本营",
    type: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "内地",
    genres: ["综艺", "游戏"],
    director: "总导演 李乐",
    actors: ["主持天团", "飞行嘉宾"],
    duration: "每期85分钟",
    language: "国语",
    rating: 7.7,
    popularity: 7360,
    poster: "https://readdy.ai/api/search-image?query=Playful%20variety%20game%20show%20poster%20with%20colorful%20balloons%20and%20confetti%20around%20a%20cheerful%20stage%2C%20bright%20coral%20and%20sunny%20yellow%20palette%2C%20fun%20joyful%20energy%2C%20clean%20playful%20design%2C%20no%20text&width=600&height=900&seq=dh-v2-poster&orientation=portrait",
    backdrop: "",
    synopsis: "经典国民综艺全新升级，每一期邀请不同嘉宾参与趣味游戏与默契挑战。轻松欢乐的氛围、随手抛出的笑点，让观众在忙碌之余获得最简单的快乐。",
    update: "更新至第 12 期"
  },
  {
    id: "v3",
    title: "环球食刻",
    type: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "内地",
    genres: ["美食", "旅行"],
    director: "总导演 陈颖",
    actors: ["美食探员团"],
    duration: "每期60分钟",
    language: "国语",
    rating: 8.5,
    popularity: 8230,
    poster: "https://readdy.ai/api/search-image?query=Warm%20food%20and%20travel%20show%20poster%20with%20a%20rustic%20table%20of%20world%20street%20food%20in%20soft%20sunlight%2C%20appetizing%20amber%20and%20fresh%20herb%20green%20palette%2C%20cozy%20inviting%20culinary%20mood%2C%20no%20text&width=600&height=900&seq=dh-v3-poster&orientation=portrait",
    backdrop: "",
    synopsis: "几位热爱美食的探员走遍世界各地，从街边小摊到米其林餐厅，寻找最地道的风味与最动人的故事。每一道菜背后，都是一段关于土地、人情与记忆的旅程。",
    update: "更新至第 9 期"
  },
  {
    id: "v4",
    title: "挑战极限",
    type: "variety",
    categoryLabel: "综艺",
    year: 2024,
    region: "内地",
    genres: ["户外", "竞技"],
    director: "总导演 赵岩",
    actors: ["极限挑战团"],
    duration: "每期95分钟",
    language: "国语",
    rating: 8.1,
    popularity: 7020,
    poster: "https://readdy.ai/api/search-image?query=Adventurous%20outdoor%20competition%20show%20poster%20with%20climbers%20conquering%20a%20rugged%20mountain%20peak%2C%20bold%20sunset%20orange%20and%20deep%20slate%20palette%2C%20dynamic%20thrilling%20energy%2C%20epic%20landscape%2C%20no%20text&width=600&height=900&seq=dh-v4-poster&orientation=portrait",
    backdrop: "",
    synopsis: "一群嘉宾走出城市，在荒野、海岛与高山之间完成一项项极限任务。体力、智慧与团队协作缺一不可，汗水与欢笑交织出最真实的挑战之旅。",
    update: "全12期 · 已完结"
  },
  {
    id: "v5",
    title: "脱口秀之夜",
    type: "variety",
    categoryLabel: "综艺",
    year: 2025,
    region: "内地",
    genres: ["喜剧", "谈话"],
    director: "总导演 王怿",
    actors: ["脱口秀演员", "特邀嘉宾"],
    duration: "每期70分钟",
    language: "国语",
    rating: 8.4,
    popularity: 8140,
    poster: "https://readdy.ai/api/search-image?query=Stand-up%20comedy%20show%20poster%20with%20a%20lone%20microphone%20under%20a%20single%20warm%20spotlight%20on%20a%20dark%20stage%2C%20rich%20amber%20and%20deep%20charcoal%20palette%2C%20intimate%20minimalist%20scene%2C%20no%20text&width=600&height=900&seq=dh-v5-poster&orientation=portrait",
    backdrop: "",
    synopsis: "把生活里的荒诞与无奈讲成段子，把平凡的日子过成笑点。来自各地的脱口秀演员轮番登台，用犀利的观察和真诚的表达，陪你笑过每一个夜晚。",
    update: "更新至第 10 期"
  },
  {
    id: "v6",
    title: "我们的歌",
    type: "variety",
    categoryLabel: "综艺",
    year: 2024,
    region: "内地",
    genres: ["音乐", "真人秀"],
    director: "总导演 林声",
    actors: ["跨界歌手", "音乐制作人"],
    duration: "每期80分钟",
    language: "国语",
    rating: 8.0,
    popularity: 6980,
    poster: "https://readdy.ai/api/search-image?query=Heartwarming%20music%20reality%20show%20poster%20with%20musicians%20playing%20acoustic%20instruments%20around%20a%20warm%20campfire%20glow%2C%20golden%20amber%20and%20teal%20accent%2C%20cozy%20intimate%20musical%20tone%2C%20no%20text&width=600&height=900&seq=dh-v6-poster&orientation=portrait",
    backdrop: "",
    synopsis: "不同年代、不同风格的音乐人两两组队，用改编与合唱碰撞出全新的火花。在一次次排练与登台之间，他们分享音乐背后的坚持与初心，也找回属于自己的那首歌。",
    update: "全10期 · 已完结"
  }
];

export const announcements = [
  { id: "n1", tag: "新片上线", text: "科幻巨制《深渊回响》现已收录，欢迎查看影片详情与看点。" },
  { id: "n2", tag: "热播推荐", text: "都市情感剧《云上之城》全集上线，年度口碑之作不容错过。" },
  { id: "n3", tag: "综艺速递", text: "《环球食刻》第九期更新，跟随探员团尝遍世界街头风味。" }
];

export const siteIntro = {
  title: "关于豆花视频",
  paragraphs: [
    "豆花视频是一个以高清影视内容为核心的展示与资讯平台，汇聚电影、电视剧、综艺等多元类型的影视资源，为用户提供清晰、便捷的内容浏览与查找体验。",
    "我们不提供在线播放与下载服务，而是专注于影片信息的整理与呈现：从主创阵容、剧情简介到类型标签与评分，帮助你在选择观看之前，快速了解一部作品的全貌。",
    "无论你是追新追热的剧迷，还是想寻找周末佳片的普通观众，都能在豆花视频找到属于自己的那一份影视清单。"
  ]
};

export const contactInfo = {
  email: "support@douhuavideo.com",
  cooperation: "biz@douhuavideo.com",
  address: "上海市浦东新区数字内容产业园 互动娱乐大厦 12 层",
  phone: "400-880-6688"
};